import { jsx as _jsx } from "react/jsx-runtime";
import { addErrorNotification, loadAppleWalletPassForJourney, NotificationType } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { useJourneyContext } from '../../../../../context/journey/hooks/use-journey-context';
import { useOccContext } from '../../../../../context/occ/hooks/use-occ-context';
import { Icon } from '../../../../../subcomponents/icon/icon';
import { getIdForComponentNotification } from '../../../../../utils/get-id-for-component-notification';
import { openAppleWalletPass } from './utils';
const b = bemClassBuilder('v-journey-action-button-apple-wallet');
export const JourneyActionButtonAppleWallet = observer(props => {
    const { accessibilityText } = useOccContext();
    const { displayText, assets } = props;
    const { journey } = useJourneyContext();
    const [isPassLoading, setIsPassLoading] = useState(false);
    if (!journey)
        return null;
    const handleClick = async (event) => {
        event.preventDefault();
        if (isPassLoading)
            return;
        setIsPassLoading(true);
        await openAppleWalletPassForJourney(journey.id, displayText);
        setIsPassLoading(false);
    };
    return (_jsx("button", Object.assign({ className: b.block({ loading: isPassLoading }), onClick: handleClick, "aria-label": accessibilityText.addToAppleWalletButtonAriaLabelFormat }, { children: _jsx(Icon, { name: assets.icon.name, className: b.element('icon'), viewBox: assets.icon.viewBox }) })));
});
JourneyActionButtonAppleWallet.displayName = 'JourneyActionButtonAppleWallet';
const openAppleWalletPassForJourney = async (journeyId, displayText) => {
    try {
        const appleWalletPass = await loadAppleWalletPassForJourney(journeyId);
        openAppleWalletPass(appleWalletPass);
    }
    catch (error) {
        addErrorNotification({
            id: getIdForComponentNotification('journey-action-button-apple-wallet', NotificationType.Error, 'open-apple-wallet-pass'),
            title: displayText.failedToLoadPassTitle,
            messages: [displayText.failedToLoadPassMessage]
        }, error);
    }
};
